/* eslint-disable react/prop-types */
import Backdrop from 'components/base/Backdrop';
import Portal from 'components/base/Portal';
import React, { useContext, useState } from 'react';

const LoadingContext = React.createContext();

export const useLoading = () => useContext(LoadingContext);

const PageLoadingProvider = ({ children }) => {
  const [loadingScope, setLoadingScope] = useState('body');
  const [modalLoading, setModalLoading] = useState({
    message: '',
    loading: false
  });

  const manageLoading = (loading = false, message = '', scope = 'body') => {
    if (typeof loading !== 'boolean') return;
    setLoadingScope(scope || 'body');
    setModalLoading({ message: message || '', loading });
  };

  return (
    <LoadingContext.Provider
      value={{
        manageLoading,
        loading: modalLoading.loading,
        loadingMessage: modalLoading.message
      }}
    >
      {children}
      <Portal containerSelector={loadingScope}>
        <Backdrop
          show={modalLoading.loading}
          className={`flex-column ${loadingScope === 'body' ? 'position-fixed' : ''}`}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mb-1">{modalLoading.message || 'Processing...'}</p>
          <p className="fs-9">please wait...</p>
        </Backdrop>
      </Portal>
    </LoadingContext.Provider>
  );
};

export default PageLoadingProvider;
